import { DIVINE_STRIKE_FEATURE_ID, divineStrikeDice, hasDivineStrike } from '../../../../shared/rules/cleric.mjs';

const LABEL = 'Divine Strike';
const TYPES = [{ id: 'radiant', label: 'Radiant' }, { id: 'necrotic', label: 'Necrotic' }];
const ineligible = (reasonCode) => ({ status: 'ineligible', featureId: DIVINE_STRIKE_FEATURE_ID, featureLabel: LABEL, reasonCode });

/**
 * Blessed Strikes: Divine Strike (Cleric 7, 2d8 at 14): once on each of its turns, a weapon hit can deal an extra 1d8
 * Necrotic or Radiant damage. Optional, so it asks; the once-per-turn claim commits with the hit like Colossus Slayer's.
 */
export const evaluateDivineStrike = ({ context }) => {
  if (!hasDivineStrike(context?.attacker?.entity)) return ineligible('no-divine-strike');
  if (context?.roll?.hit === false) return ineligible('not-a-hit');
  if (!context?.attack?.isWeaponAttack) return ineligible('not-weapon-attack');
  const combat = context.combat;
  if (!combat?.campaignId || !Number.isInteger(combat?.turnSequence) || !combat?.activeCombatantId || combat.activeCombatantId !== context.attacker?.combatantId) return ineligible('not-your-turn');
  const previous = combat.turnFeatureUsage?.[context.attacker.combatantId]?.[DIVINE_STRIKE_FEATURE_ID];
  if (previous?.turnSequence === combat.turnSequence && previous.resolutionId !== context.resolutionId) return ineligible('already-used-this-turn');
  const dice = divineStrikeDice(context.attacker.entity);
  const base = { featureId: DIVINE_STRIKE_FEATURE_ID, featureLabel: LABEL, reasonCode: 'weapon-hit', components: [], claims: [] };
  return {
    status: 'confirmation-required', ...base,
    decision: {
      id: `${context.resolutionId}:${DIVINE_STRIKE_FEATURE_ID}`, kind: 'confirm-feature', featureId: DIVINE_STRIKE_FEATURE_ID,
      resolutionId: context.resolutionId, title: LABEL, label: LABEL, prompt: `Add ${dice}d8 to this hit? Once on each of your turns.`,
      choices: [...TYPES.map(({ id, label }) => ({ id, action: 'apply', label: `${dice}d8 ${label}` })), { id: 'skip', label: 'No' }],
    },
    resolveDecision: (choiceId) => {
      const type = TYPES.find(({ id }) => id === choiceId);
      if (!type) return base;
      return { ...base,
        components: [{ id: DIVINE_STRIKE_FEATURE_ID, label: LABEL, source: { type: 'feature', featureId: DIVINE_STRIKE_FEATURE_ID }, dice: { count: dice, sides: 8 }, flat: 0,
          damageType: { mode: 'explicit', value: type.id }, critical: { dice: 'double' } }],
        claims: [{ campaignId: combat.campaignId, combatantId: context.attacker.combatantId, featureId: DIVINE_STRIKE_FEATURE_ID, turnSequence: combat.turnSequence, resolutionId: context.resolutionId }] };
    },
  };
};
